import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  getSensors as onGetSensors,
  setSensorsDataReady as onSetSensorsDataReady,
  setSensorsDataEmpty as onSetSensorsDataEmpty
} from './../../actions/sensorsActions'

const mapStateToProps = (state) => ({
  sensorsDataState: state.sensors.dataState,
  sensorsData: {
    date: get(state, ['sensors', 'data', 'date'], null),
    number: get(state, ['sensors', 'data', 'number'], 0),
    location: {
      lat: get(state, ['sensors', 'data', 'location', 'lat'], 0),
      long: get(state, ['sensors', 'data', 'location', 'long'], 0)
    },
    state: {
      status: get(state, ['sensors', 'data', 'state', 'status'], 0),
      address: get(state, ['sensors', 'data', 'state', 'address'], '')
    },
    sensors: get(state, ['sensors', 'data', 'sensors'], {}),
  },
  sensorsErrors: state.sensors.errors,
  isSensorsDataReady: state.sensors.isDataReady
})

const mapDispatchToProps = {
  onGetSensors,
  onSetSensorsDataReady,
  onSetSensorsDataEmpty
}

const withSensors = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withSensors }